module.exports = __webpack_public_path__ + "img/esporodquio 2.73c32861.webp";